import { Status } from "../types";

export const canCancelPostOrder = (status: Status) => {
  if (
    status === "NEW" ||
    status === "STARTING" ||
    status === "IN_PROGRESS" ||
    status === "CHECKING" ||
    status === "PAUSED"
  ) {
    return true;
  }
  return false;
};
